<template>
  <v-app-bar
    app
    color="primary"
    dark
  >
    <div class="d-flex align-center">
      <a href="https://www.rufftuff.com">
        <v-img
          contain
          src="../assets/images/rt-logo.svg"
          transition="scale-transition"
          width="160"
        />
      </a>
    </div>

    <v-spacer></v-spacer>

    <User />
  </v-app-bar>
</template>

<script>
import User from './User'

export default {
  components: {
    User
  }
}
</script>

